<template>
    <v-row>
        <v-col cols="12" class="pb-1">
            <v-divider class="mb-5"></v-divider>
            <div class="d-flex justify-space-between align-center">
                <span class="title">
                    <v-icon>calendar_today</v-icon>
                    {{ $t('contracts.form.deadline.title') }}
                </span>
                <contract-deadline-dialog :show.sync="deadlineDialog.show" :setup.sync="setup" :contract.sync="contract" @close-deadline-dialog="reOrder"></contract-deadline-dialog>
            </div>
        </v-col>
        <v-col cols="12" v-if="contract.deadline.length < 1">
            <div class="text-center"><span style="color: red">{{ $t('contracts.form.deadline.empty') }}</span></div>
        </v-col>
        <v-col cols="12" class="pt-1" v-else>
            <v-list dense>
                <template v-for="(item, index) in contract.deadline">
                    <v-list-item :key="index" v-if="!item.isDone || viewDeadlines">
                        <v-list-item-action @click="completeDeadline(item)">
                            <v-checkbox
                                v-model="item.isDone"
                                readonly
                            ></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content class="deadline-item" :class="{ checked: item.isDone }">
                            <v-list-item-title>{{item.deadline | momentFormatDateNoISO('L')}} - {{item.name}}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="error"
                                text
                                @click.prevent="deleteDeadline(index, item)"
                            >
                                {{ $t('common.remove') }}
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-list>
        </v-col>
        <v-col cols="12" v-if="hasDeadlineDone">
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="toggleDeadlineDone()"
                small
            >
                {{viewDeadlines ? $t('contracts.form.deadline.hideDones') : $t('contracts.form.deadline.showDones')}}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import ContractDeadlineDialog from '@/components/contract/ContractDeadlineDialog'

export default {
    name: 'contract-deadline',
    props: ['setup', 'contract'],
    components: {
        ContractDeadlineDialog
    },
    data () {
        return {
            viewDeadlines: false,
            deadlineDialog: {
                show: false
            }
        }
    },
    computed: {
        hasDeadlineDone () {
            let deadlinesDone = this.contract.deadline.filter(function (deadline) {
                return deadline.isDone === true
            })
            return (deadlinesDone.length > 0)
        }
    },
    methods: {
        completeDeadline (deadline) {
            window.getApp.refreshContracts = true
            deadline.isDone = !deadline.isDone
        },
        deleteDeadline (index, deadline) {
            window.getApp.refreshContracts = true
            this.contract.deadline.splice(index, 1)
        },
        reOrder () {
            this.contract.deadline.sort(function (a, b) {
                if (a.deadline.toLowerCase() < b.deadline.toLowerCase()) return -1
                if (a.deadline.toLowerCase() > b.deadline.toLowerCase()) return 1
            })
        },
        toggleDeadlineDone () {
            this.viewDeadlines = !this.viewDeadlines
        }
    }
}
</script>

<style lang="stylus" scoped>
    .v-list-item
        background: rgba(253, 253, 253, 0.5)
    .v-list-item:nth-child(even)
        background: rgba(243, 243, 243, 0.5)
    .deadline-item.checked
        .v-list-item__title
            text-decoration: line-through
    .v-list-item:hover
        background-color: #eeeeee
        cursor: pointer
</style>
